import { course as courseStore } from '@/stores/CourseStore'
import { getErrorMessage } from '@/utils/helpers'

import axios from './instance'
export const submitFeedback = async ({ data, eventId }) => {
  const { course, courseContent, quizQuestion } = courseStore
  const url = window.location.href
  try {
    return await axios.post('/feedback/', {
      ...data,
      course,
      courseContent,
      quizQuestion,
      extraContext: { eventId },
      url,
    })
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
